import { Grid, Skeleton } from '@mui/material';

interface SkeletonCardProps {
  count?: any; // Optional count prop
}

export default function Preload({ count }: SkeletonCardProps) {

  // const skeletonCount = count ?? (count ? Number(count) : 5);

  return (
    <Grid container spacing={2}>
      {Array.from({ length: Number(count) || 5 }).map((_, index) => (
        <Grid item xs={6} sm={4} md={3} lg={2.4} xl={2} xxl={1.5} key={index}>
          <Skeleton
            animation="wave"
            variant="rounded"
            height={200}
            sx={{ mb: .5, borderRadius: "8px", width: "100%" }}
          />
          <Skeleton
            animation="wave"
            variant="rounded"
            height={20}
            sx={{ mb: .5, borderRadius: "8px", width: "100%" }}
          />
          <Skeleton
            animation="wave"
            variant="rounded"
            height={25}
            sx={{ borderRadius: "8px", width: "100%" }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
